angular.module('ikeweb.user').controller('planSelectorController', ['$scope',
    function($scope) {
        $scope.isSelected = function(planName) {
            if ($scope.selectedPlan == null) {
                return false;
            }
            return $scope.selectedPlan.interval === planName;
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/plan/plan.selector.controller.js
// module id = 509
// module chunks = 0